module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_8017.a3247068.png";